import React from "react";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/authContext";
import Routes from "./Routes";

function App() {
  const basename = process.env.REACT_APP_BASENAME || "/";

  return (
    <BrowserRouter basename={basename}>
      <AuthProvider>
        <Routes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
